import { defineMessages, MessageDescriptor } from 'react-intl';
import type { AssetStyleId, WaveformShape } from 'fym-shared/src/music24/assetStyles';

const messages = defineMessages({
  coverCardName: { id: 'app.sml.promote.studio.style.coverCard.name', defaultMessage: 'Cover card' },
  coverCardLine: { id: 'app.sml.promote.studio.style.coverCard.line', defaultMessage: 'The cover as a card' },
  coverGroundName: { id: 'app.sml.promote.studio.style.coverGround.name', defaultMessage: 'Cover ground' },
  coverGroundLine: {
    id: 'app.sml.promote.studio.style.coverGround.line',
    defaultMessage: 'The cover, blurred, behind large type',
  },
  typeOnlyName: { id: 'app.sml.promote.studio.style.typeOnly.name', defaultMessage: 'Type only' },
  typeOnlyLine: { id: 'app.sml.promote.studio.style.typeOnly.line', defaultMessage: 'Large type, no cover' },
  driftName: { id: 'app.sml.promote.studio.style.drift.name', defaultMessage: 'Cover drift' },
  driftLine: { id: 'app.sml.promote.studio.style.drift.line', defaultMessage: 'The cover moves slowly' },
  pulseName: { id: 'app.sml.promote.studio.style.pulse.name', defaultMessage: 'Pulse' },
  pulseLine: { id: 'app.sml.promote.studio.style.pulse.line', defaultMessage: 'Cover and bars on the beat' },
  liquidName: { id: 'app.sml.promote.studio.style.liquid.name', defaultMessage: 'Liquid' },
  liquidLine: { id: 'app.sml.promote.studio.style.liquid.line', defaultMessage: 'The colours flow' },
  waveformName: { id: 'app.sml.promote.studio.style.waveform.name', defaultMessage: 'Waveform' },
  waveformLine: { id: 'app.sml.promote.studio.style.waveform.line', defaultMessage: 'The cover and one shape' },
  particlesName: { id: 'app.sml.promote.studio.style.particles.name', defaultMessage: 'Particles' },
  particlesLine: { id: 'app.sml.promote.studio.style.particles.line', defaultMessage: 'Dots that rise with the song' },
  aiFootageName: { id: 'app.sml.promote.studio.style.aiFootage.name', defaultMessage: 'AI footage' },
  aiFootageLine: { id: 'app.sml.promote.studio.style.aiFootage.line', defaultMessage: 'AI clips cut on the beat' },
});

export interface AssetStyleMessages {
  name: MessageDescriptor;
  line: MessageDescriptor;
}

/** The name and the one line of each style (design q3b, q3c). */
export const assetStyleMessages: Record<AssetStyleId, AssetStyleMessages> = {
  coverCard: { name: messages.coverCardName, line: messages.coverCardLine },
  coverGround: { name: messages.coverGroundName, line: messages.coverGroundLine },
  typeOnly: { name: messages.typeOnlyName, line: messages.typeOnlyLine },
  drift: { name: messages.driftName, line: messages.driftLine },
  pulse: { name: messages.pulseName, line: messages.pulseLine },
  liquid: { name: messages.liquidName, line: messages.liquidLine },
  waveform: { name: messages.waveformName, line: messages.waveformLine },
  particles: { name: messages.particlesName, line: messages.particlesLine },
  aiFootage: { name: messages.aiFootageName, line: messages.aiFootageLine },
};

/** The waveform shapes (design q3b, q3e). */
export const waveformShapeMessages: Record<WaveformShape, MessageDescriptor> = defineMessages({
  bars: { id: 'app.sml.promote.studio.waveform.bars', defaultMessage: 'Bars' },
  line: { id: 'app.sml.promote.studio.waveform.line', defaultMessage: 'Line' },
  ring: { id: 'app.sml.promote.studio.waveform.ring', defaultMessage: 'Ring' },
  none: { id: 'app.sml.promote.studio.waveform.none', defaultMessage: 'None' },
});
